// extracted by mini-css-extract-plugin
module.exports = {"seo_blocks_wrapper":"styles_seo_blocks_wrapper__cWP2o","seo_block_width_container":"styles_seo_block_width_container__Z8Mhb"};